/* eslint-disable no-unused-vars */
export enum Tier {
	FREE = 'FREE',
	PREMIUM = 'PREMIUM',
}
